import React, { useState } from "react";
import SubNavbar from "../component/SubNavbar";
import HomeBanner from "../component/Home/HomeBanner";
import LiveRates from "../component/Home/LiveRates";
import OverPaying from "../component/Home/OverPaying";
import ConversionChart from "../component/Home/ConversionChart";
import TopCurrencies from "../component/Home/TopCurrencies";

const Home = () => {
  const [selectedCurrency, setSelectedCurrency] = useState({
    currencyCode: "GBP",
    currencyName: "Pound Sterling",
  });
  const [convertSelectedCurrency, setConvertSelectedCurrency] = useState({
    currencyCode: "EUR",
    currencyName: "Euro",
  });
  const [amount, setAmount] = useState(1000);
  const [convertAmount, setConvertAmount] = useState("");
  const [conversionRate, setConvertionRate] = useState("");

  return (
    <>
      <SubNavbar />
      <HomeBanner
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        convertSelectedCurrency={convertSelectedCurrency}
        setConvertSelectedCurrency={setConvertSelectedCurrency}
        amount={amount}
        setAmount={setAmount}
        convertAmount={convertAmount}
        setConvertAmount={setConvertAmount}
        setConvertionRate={setConvertionRate}
        conversionRate={conversionRate}
      />
      <LiveRates />
      <div className="bg-gray-50 py-8">
        <div className="lg:max-w-5xl container px-12  bg-white shadow-xl mx-auto rounded-xl py-4">
          <ConversionChart
            convertSelectedCurrency={convertSelectedCurrency}
            selectedCurrency={selectedCurrency}
            conversionRate={conversionRate}
          />
        </div>
        <TopCurrencies />
      </div>
      <OverPaying />
    </>
  );
};

export default Home;
